"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireDefault(require("react")),
  _queryString = _interopRequireDefault(require("query-string")),
  _excluded = ["field", "value", "validationMessage", "touched", "setTouched", "updateForm", "cssClass"],
  _default = exports["default"] = function (a) {
    var b = a.field,
      c = a.value,
      d = a.validationMessage,
      e = a.touched,
      f = a.setTouched,
      g = a.updateForm,
      h = a.cssClass,
      i = (0, _objectWithoutProperties2["default"])(a, _excluded),
      j = b.id,
      k = b.type,
      l = b.isRequired,
      m = b.customName,
      n = b.formId,
      o = !1;
    if (b.allowsPrepopulate) {
      var p = _queryString["default"].parse(location.search);
      o = p[b.inputName];
    }
    return _react["default"].createElement("div", {
      className: h
    }, _react["default"].createElement("input", {
      name: m || "input_".concat(j),
      type: k,
      value: o ? o : c,
      required: l,
      onChange: function onChange(a) {
        return g(a, b);
      },
      onBlur: function onBlur(a) {
        g(a, b), f(j);
      },
      "aria-describedby": "error_".concat(n, "_").concat(j),
      "aria-invalid": !!d
    }), d && e && _react["default"].createElement("span", {
      className: "error-message",
      id: "error_".concat(n, "_").concat(j)
    }, d));
  };